import React from "react";
import { ActivationSalesLineChart } from "../../../../components/chart/activationSalesLineChart";
import Spinner from "../../../../components/presentationals/Spinner";
import Error from "../../../../components/Error/index";
import { useSelector } from "react-redux";

const Last7DaysView = ({ handleChange, isCsvActive, days, fetchCsv }) => {
  const { last7DaysObj, actCsvLoading } = useSelector(
    (state) => state.activationSalesReducer
  );
  let { last7DaysData } = last7DaysObj;

  return (
    <>
      {last7DaysObj.loading ? (
        <Spinner />
      ) : Object.keys(last7DaysData).length ? (
        <>
          <div className="col-md-12">
            <div className="roundborder actc">
              <div className="mdnsubtitle">
                <div className="leftdiv">Activation Trend</div>
              </div>
              {isCsvActive === "Y" ? (
                <>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <div className="col-6 col-md-2">
                      <select
                        className="form-control"
                        id="sel1"
                        name="sellist1"
                        onChange={handleChange("unit")}
                      >
                        {days.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-2 col-md-1">
                      {actCsvLoading && actCsvLoading["last"] ? (
                        <Spinner showAlert={false} />
                      ) : (
                        <button
                          type="button"
                          className="btn btn-link btn-sm m-0 p-0"
                          onClick={fetchCsv}
                        >
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/icons/download-arrow.svg"
                            }
                            alt="download"
                          />
                        </button>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
              <div className="row">
                <div className="col-md-3">
                  <div className="h-100">
                    <div className="datatable" data-cy="earnings-table">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th scope="col" style={{ fontWeight: "bold" }}>
                              Day
                            </th>
                            <th
                              scope="col"
                              style={{ fontWeight: "bold", textAlign: "end" }}
                            >
                              Count
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.entries(last7DaysData).map(
                            ([day, data], index) => (
                              <tr key={index}>
                                <td>Day {index + 1}</td>
                                <td style={{ textAlign: "end" }}>{data}</td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="col-md-9">
                  <div className="h-100">
                    <ActivationSalesLineChart content={last7DaysData} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <Error error={last7DaysObj.error} />
      )}
    </>
  );
};

export default Last7DaysView;
